import { render, staticRenderFns } from "./about.vue?vue&type=template&id=24941273&scoped=true&"
import script from "./about.vue?vue&type=script&lang=js&"
export * from "./about.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/page_style/about.scss?vue&type=style&index=0&id=24941273&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24941273",
  null
  
)

export default component.exports